//eslint-disable-next-line @wix/santa-editor/scoped-imports, @typescript-eslint/no-restricted-imports
import '@/rEditor/editor.global.scss';
import '@wix/design-system/styles.global.css';
/**
 * Fonts that we use are compressed and some symbols are missing.
 * Because of this, Vietnamese looks bad. Different symbols are rendered with different fonts.
 * We need to use other fonts. This is expected to be fixed by uploading full versions of fonts,
 * but meanwhile we need to add fallback fonts for Vietnamese locale
 * TODO: remove editor-vi-fonts.global.scss after main fonts are updated to include all needed symbols
 */
//eslint-disable-next-line @wix/santa-editor/scoped-imports, @typescript-eslint/no-restricted-imports
import('@/rEditor/editor-vi-fonts.global.scss');
//order matters!
import { startup } from './startup.esbuild';

//hotfixes, todo rm
window.santaBase = 'https://static.parastorage.com/services/santa/1.11783.0';
///end hotfixes

startup({
  isInsideEditorX: false,
  measureFrameRate: true,
  shouldBiErrorsAndFedops: true,
  shouldRender: true,
});
